import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import Defs from '@bubble-ui/primitive-defs';
import LinearGradient from '@bubble-ui/primitive-linear-gradient';
import Stop from '@bubble-ui/primitive-stop';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var ColoredIllustrationInstallments = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 100,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'ColoredIllustrationInstallments',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 100 100",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint0_linear_21134_70511)",
    fillRule: "evenodd",
    d: "M43.5 97.62h.08C65.9 97.62 84 79.53 84 57.2H43.5v40.42Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint1_linear_21134_70511)",
    fillRule: "evenodd",
    d: "M43.5 16.78C21.21 16.82 3.15 34.9 3.15 57.2H43.5V16.78Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint2_linear_21134_70511)",
    fillRule: "evenodd",
    d: "M3.16 57.02v.18c0 22.3 18.06 40.38 40.35 40.42v-40.6H3.16Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#FFCB97",
    fillRule: "evenodd",
    d: "M96.65 44.85v-.08c0-22.33-18.1-40.42-40.42-40.42h-.08v40.5h40.5Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#E56767",
    fillRule: "evenodd",
    d: "M96.1 44.85S77.57 8.35 56.22 8.35h-.08v7.9h.06c16.95 0 30.86 12.43 32.78 28.6h7.12Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#F1DD73",
    fillRule: "evenodd",
    d: "M56.23 4.35h-.08v7.9h.06c17.97 0 32.54 14.57 32.54 32.54v.06h7.9v-.08c0-22.32-18.1-40.42-40.42-40.42Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#E14E73",
    fillRule: "evenodd",
    d: "M72.87 42.17c0-2.45-1.96-4.44-4.38-4.44s-4.38 1.99-4.38 4.44c0 1.01.34 1.93.9 2.67h6.95c.56-.74.91-1.66.91-2.67Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#E14E73",
    d: "M75.47 36.05c2.419 0 4.38-1.988 4.38-4.44 0-2.452-1.961-4.44-4.38-4.44-2.42 0-4.38 1.988-4.38 4.44 0 2.452 1.96 4.44 4.38 4.44Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#E14E73",
    fillRule: "evenodd",
    d: "M56.15 30.91c.91 1.18 2.31 1.96 3.9 1.96 2.74 0 4.97-2.26 4.97-5.04 0-2.78-2.22-5.04-4.97-5.04-1.59 0-2.99.77-3.9 1.96v6.16Z"
  }), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint0_linear_21134_70511",
    x1: 49.909,
    x2: 70.234,
    y1: 39.384,
    y2: 95.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.256,
    stopColor: "#65CFFD"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.413,
    stopColor: "#64B4F8"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.651,
    stopColor: "#6292F1"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.847,
    stopColor: "#607DED"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.976,
    stopColor: "#6075EC"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint1_linear_21134_70511",
    x1: 11.059,
    x2: 48.282,
    y1: 3.286,
    y2: 105.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.148,
    stopColor: "#FEF7B5"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.511,
    stopColor: "#9E58FF"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint2_linear_21134_70511",
    x1: 14.664,
    x2: 37.675,
    y1: 36.892,
    y2: 100.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#ECE1FB"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#F45FF6"
  }))));
};
ColoredIllustrationInstallments.displayName = 'ColoredIllustrationInstallments';
export default withProvisionalOverrideFromContext(ColoredIllustrationInstallments);
//# sourceMappingURL=index.js.map